import { useApi } from '@/api';
import { KpiSkeleton, LinkButton } from '@/components';
import {
  Box,
  BoxProps,
  Card,
  CurrencyValue,
  Flex,
  Heading
} from '@blockanalitica/ui';
import styled from 'styled-components';

const TotalBox = styled(Box)<BoxProps>`
  font-weight: 700;
  color: ${(props) => props.theme.colors['muted']};
  padding-top: ${(props) => props.theme.space['3xs']};
`;

export default function PortfolioDetails({ ilk }) {
  const [data, error] = useApi({
    url: `/rwa/${ilk}/portfolio/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  if (data.name === null) {
    return <></>;
  }

  return (
    <Card>
      <Flex justifyContent="space-between">
        <Heading size="2">Portfolio Details</Heading>
        <LinkButton size="small" to="portfolio" height="1.2rem">
          view more
        </LinkButton>
      </Flex>
      <Flex flexDirection={['column', 'row']} gap="m">
        <Flex flexBasis="100%" flexDirection="column" gap="xs">
          <Heading size="4" color="muted">
            NAV
          </Heading>
          <Flex justifyContent="space-between">
            <Box>T-Bill Balance (Cost)</Box>
            <CurrencyValue value={data.asset_value} />
          </Flex>
          <Flex justifyContent="space-between">
            <Box>T-Bill Accrued Interest</Box>
            <CurrencyValue value={data.accrued_interest} />
          </Flex>
          <Flex justifyContent="space-between">
            <Box>Cash Balance</Box>
            <CurrencyValue value={data.cash_balance} />
          </Flex>
          <Flex justifyContent="space-between">
            <TotalBox>Total</TotalBox>
            <TotalBox>
              <CurrencyValue value={data.total_nav} />
            </TotalBox>
          </Flex>
        </Flex>
        <Flex flexBasis="100%" flexDirection="column" gap="xs">
          <Heading size="4" color="muted">
            Net Stability Fees
          </Heading>
          <Flex justifyContent="space-between">
            <Box>Gross Stability Fees (Realized)</Box>
            <CurrencyValue value={data.fees_realized} />
          </Flex>
          <Flex justifyContent="space-between">
            <Box>Gross Stability Fees (Unrealized)</Box>
            <CurrencyValue value={data.interest_income} />
          </Flex>
          <Flex justifyContent="space-between">
            <Box>Total Expenses</Box>
            <CurrencyValue value={data.total_expanse} />
          </Flex>
          <Flex justifyContent="space-between">
            <TotalBox>Total</TotalBox>
            <TotalBox>
              <CurrencyValue value={data.total_fees} />
            </TotalBox>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
